import React, { useState } from 'react'

export default function TableCellCheckbox(props) {
  const [isChecked, setIsChecked] = useState(!!props.value)

  const onChange = () => {
    props.onUpdate(!isChecked)
    setIsChecked(!isChecked)
  }

  return <input type={'checkbox'} checked={!!props.value} onInput={onChange} />
}
